import React from 'react';
import { MenuButton, MainMenu, SimpleSidebar, SidebarDirection } from '@adjust/dashboard-components';
import { UseCurrentUser } from '../../types';
import { useSidebar } from '../../hooks/useSidebar';
import { useTranslate } from 'src/hooks/useTranslate';

interface Props {
  currentUser: UseCurrentUser;
}

export const Header: React.FC<Props> = ({ currentUser }) => {
  const sidebar = useSidebar();
  const translate = useTranslate();

  return (
    <div className="header">
      <MenuButton ariaLabel="Menu" onClick={sidebar.open} />
      <h1>Deeplink Generator</h1>

      <SimpleSidebar
        name="sidebar"
        direction={SidebarDirection.Left}
        isVisible={sidebar.isOpened}
        onClose={sidebar.close}
      >
        {() => (
          <MainMenu
            currentUser={currentUser.user as any}
            currentAccount={currentUser.account as any}
            accounts={currentUser.accounts}
            language={'en' as any}
            baseUrl=""
            activeLink="deeplink"
            t={translate}
            toggleSidebar={sidebar.toggle}
            switchAccount={currentUser.switchAccount}
            searchAccount={currentUser.searchAccount}
            logout={currentUser.logout}
          />
        )}
      </SimpleSidebar>
    </div>
  );
};
